import { ALPHA__Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";

import { CreditOffersGroup } from "../SideDrawer/CreditOfferGroup/CreditOffersGroup";
import { Disclaimer } from "../SideDrawer/Disclaimer";
import { CreditIllustration } from "../../../../types/cobeTypes";

const getCreditOffersByType = (creditOffers: CreditIllustration[]) => {
  const ibcOffersGroups: CreditIllustration[][] = [];
  const ifcOffers: CreditIllustration[] = [];

  creditOffers.forEach((creditOffer: CreditIllustration) => {
    if (creditOffer.financialProductType === "IFC") ifcOffers.push(creditOffer);

    if (creditOffer.financialProductType === "IBC") {
      const targetGroup = ibcOffersGroups.find(
        (ibcOffersGroup) =>
          // @ts-ignore
          ibcOffersGroup[0].creditRate.value === creditOffer.creditRate.value,
      );
      targetGroup
        ? targetGroup.push(creditOffer)
        : ibcOffersGroups.push([creditOffer]);
    }
  });
  return { ibcOffersGroups, ifcOffers };
};

interface CreditOffersSideDrawerProps {
  handleClose: () => void;
  drawerIsOpen: boolean;
  creditOffers: CreditIllustration[];
  ifcDisclaimerAnalyticsClickHandler?: (subtype: string) => void;
  ibcDisclaimerAnalyticsClickHandler?: (type: string, subtype: string) => void;
}

export const CreditOffersSideDrawer = ({
  handleClose,
  drawerIsOpen,
  creditOffers,
  ifcDisclaimerAnalyticsClickHandler,
  ibcDisclaimerAnalyticsClickHandler,
}: CreditOffersSideDrawerProps) => {
  const { ifcOffers, ibcOffersGroups } = getCreditOffersByType(creditOffers);

  const handleDisclaimerClick = () => {
    if (ifcOffers.length && ifcDisclaimerAnalyticsClickHandler) {
      ifcDisclaimerAnalyticsClickHandler("credit component - find out more");
    } else if (ibcOffersGroups.length && ibcDisclaimerAnalyticsClickHandler) {
      ibcDisclaimerAnalyticsClickHandler("pdp fs slide draw", "credit info");
    }
  };

  return (
    <ALPHA__Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      header="Payment plans"
      isDrawerLeft={false}
      isHeaderFixed={true}
      isNarrow={false}
      fullPage={true}
      rootId={"page-root"}
      isLegacySPDPDrawer={true}
    >
      {ifcOffers.length ? (
        <CreditOffersGroup creditOfferGroup={ifcOffers} type={"IFC"} />
      ) : null}
      {ibcOffersGroups.length
        ? ibcOffersGroups.map((ibcOffersGroup, index) => (
            <CreditOffersGroup
              creditOfferGroup={ibcOffersGroup}
              type={"IBC"}
              key={index}
            />
          ))
        : null}
      <Disclaimer disclaimerClickHandler={handleDisclaimerClick} />
    </ALPHA__Drawer>
  );
};
